/**
 * @module  Experience/Softgoods
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */
/* tslint:disable: no-loop-func max-file-line-count*/
// Core Libraries
import { Component, OnInit, Input, Output, OnDestroy, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Wove } from 'aspect.js/';
import { SafeHtml } from '@angular/platform-browser';

// Services

// Constants
import {
  SHARED_BROWSE_COMPONENTS,
} from '@experience/shop/shared-browse/constants/shared-browse.constants';
import { PlanOption } from '@support/api/proxies/responses/api-2117.interface';

// PDL
import { PDLBaseComponent } from '@experience/reb-pdl/components/pdl.base.component';
import { PdlService } from '@experience/reb-pdl/services/pdl.service';
import { BrowsePlanConfig } from '@core/aem/interfaces/shop/browse-plan.interface';
import { FamilyPlan } from '@experience/shop/softgoods/interfaces/family-plan.interface';
import { StaticModal } from '@support/shared/widgets/interfaces/static-modal.interface';

@Wove({ moduleName: SHARED_BROWSE_COMPONENTS.PLAN_FAMILY_MODULE })
@Component({
  selector: 'tmo-data-only-plans',
  templateUrl: './data-only-plans.component.html',
})
export class DataOnlyPlansComponent extends PDLBaseComponent implements OnInit, OnDestroy {
  @Input() public familyPlanOptions: PlanOption[];
  @Input() public set selectedPlanId(planId: string) {
    this.planSelectedId = planId;
  }
  @Input() public selectedPlanItem: PlanOption;
  @Input() public aemContent: BrowsePlanConfig;
  @Input() public isEdit: boolean;
  @Output() public selectedPlan: EventEmitter<PlanOption>;
  @Output() public showPlanDetailModal: EventEmitter<PlanOption>;
  @Output() public routeToCart: EventEmitter<boolean>;
  @Input() public planFamilyDetails: FamilyPlan;
  public planSelectedId: String;
  public planSelectedIdCheck: String;
  /**
   * Variable to check if it is add a fan flow
   */
  @Input() public isAddAFan: boolean;
  /**
   * Flag to check whether the plans are displayed on Product Selector
   */
  @Input() public isProductSelector?: boolean;

  public pricingDisclaimer: string;
  @Input() public fccLabelLinkText: string;
  @Input() public fccLabelLinkUrl: string;
  /*
   * promotion banner header text and icon
   */
  @Input() public promotionTagIconTemplate: SafeHtml;
  @Input() public planPromotions: { [key: string]: string } = {};
  @Input() public isCPS: boolean;
  @Input() public autopayDiscountDetailsModal: StaticModal;
  @Input() public showAutoPayDiscountContent: boolean;
  constructor(
    public pdlService: PdlService,
    public routeSnapshot: ActivatedRoute
  ) {
    super(pdlService, routeSnapshot);
    this.selectedPlan = new EventEmitter<PlanOption>();
    this.showPlanDetailModal = new EventEmitter<PlanOption>();
    this.routeToCart = new EventEmitter<boolean>();
  }

  public ngOnInit(): void {
    this.planSelectedIdCheck = this.planSelectedId;
    this.pricingDisclaimer =
      (this.aemContent &&
        this.aemContent.planFamiliesContent &&
        JSON.parse(this.aemContent.planFamiliesContent)[this.planFamilyDetails.familyId][
          'DCC_pricingDisclaimer'
        ]) ||
      '';
  }

  /**
   * Method to destroy service data.
   * @returns void
   */
  public ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  public updateSelectedPlan(selectedPlan?: PlanOption, index?: number): void {
    this.planSelectedIdCheck = null;
    this.selectedPlan.emit(selectedPlan);
    if (!this.isProductSelector) {
      this.planSelectedId = selectedPlan.planOptionSelectorId;
    }
  }

  public showPlanDetailsModal(selectedPlan: PlanOption): void {
    this.showPlanDetailModal.emit(selectedPlan);
  }

  public goToCart(): void {
    this.routeToCart.emit(true);
  }

  /**
   * Toggle AutoPay Discount details Modal display
   * @param openModal 
   */
  public toggleAutopayDiscountDetailsModal(openModal: boolean): void {
    this.autopayDiscountDetailsModal.toggleModalEmitter.emit({open: openModal, close: !openModal});
  }

}
